import { Participant } from "../models/Participant";
import moment from "moment";

export const generateCalendarEvents = (
  rotation: any,
  startDate: string,
  days: number = 90,
  participants: Participant[] = [],
) => {
  const events: { title: string; start: string; id: string }[] = [];
  const start = moment(startDate).startOf("day");

  for (let i = 0; i < days; i++) {
    const date = start.clone().add(i, "days");
    const dayOfWeek = date.day().toString();
    const block = rotation?.[dayOfWeek];

    if (block) {
      const participant = participants.find((p) => p._id === block.participant);
      events.push({
        title: `Custody: ${participant?.name} (${block.startTime} - ${block.endTime})`,
        start: date.format("YYYY-MM-DD"), // ✅ Correct key
        id: `${block._id}-${i}`,
      });
    }
  }

  return events;
};
